<div class="filter-bar">
  <ng-content select="[filter-bar-front]"></ng-content>
  <div class="filter-chips">
    <framework-simple-search-input
      [searchText]="filteredText.length > 0 ? filteredText[0].value : ''"
      (searchTextChange)="textChanged($event)"
      *ngIf="text === true"
    >
    </framework-simple-search-input>

    <ng-container *ngFor="let roFilter of readOnlyFilters">
      <shared-filter-chip
        *ngIf="roFilter.type !== 'status'; else statusChip"
        [icon]="iconFromFilterType(roFilter)"
        [caption]="roFilter.displayName"
        [selected]="true"
        [disabled]="true"
      >
      </shared-filter-chip>

      <ng-template #statusChip>
        <framework-work-status-chip [workStatus]="{ id: roFilter.value, displayName: roFilter.displayName }">
        </framework-work-status-chip>
      </ng-template>
    </ng-container>

    <shared-filter-chip
      *ngFor="let product of filteredContentTypes"
      icon="category"
      [caption]="product.displayName"
      [selected]="true"
      (click)="openFilterPanel('Content Type')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let tag of filteredTags"
      icon="sell"
      [caption]="tag.displayName"
      [selected]="true"
      (click)="openFilterPanel('Tags')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let campaign of filteredCampaigns"
      icon="campaign"
      [caption]="campaign.displayName"
      [selected]="true"
      (click)="openFilterPanel('Campaign')"
    >
    </shared-filter-chip>

    <framework-work-status-chip
      [workStatus]="{ id: status.value, displayName: status.displayName }"
      *ngFor="let status of filteredStatuses"
      (click)="projectStatuses === true ?  openFilterPanel('ProjectStatus') : openFilterPanel('Status')"
    >
    </framework-work-status-chip>

    <shared-filter-chip
      *ngFor="let sow of filteredSows"
      icon="receipt"
      [caption]="sow.displayName"
      [selected]="true"
      (click)="openFilterPanel('Sow')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let owner of filteredOwners"
      icon="person"
      [caption]="owner.displayName"
      [selected]="true"
      (click)="openFilterPanel('Owner')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let owner of filteredOwnersByTeam"
      icon="person"
      [caption]="owner.displayName"
      [selected]="true"
      (click)="openFilterPanel('OwnerTeam')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let team of filteredTeams"
      icon="people"
      [caption]="team.displayName"
      [selected]="true"
      (click)="openFilterPanel('Team')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let month of filteredMonths"
      icon="receipt"
      [caption]="month.displayName"
      [selected]="true"
      (click)="openFilterPanel('Month')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let department of filteredDepartments"
      icon="groups_2"
      [caption]="department.displayName"
      [selected]="true"
      (click)="openFilterPanel('Department')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let org of filteredOrganizations"
      icon="corporate_fare"
      [caption]="org.displayName"
      [selected]="true"
      (click)="openFilterPanel('Organization')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let org of filteredIndustrySectors"
      icon="factory"
      [caption]="org.displayName"
      [selected]="true"
      (click)="openFilterPanel('IndustrySector')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let template of filteredTemplates"
      icon="view_timeline"
      [caption]="template.displayName"
      [selected]="true"
      (click)="openFilterPanel('Template')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let productClass of filteredProductClasses"
      icon="category"
      [caption]="productClass.displayName"
      [selected]="true"
      (click)="openFilterPanel('ProductClass')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let unit of filteredUnits"
      icon="star"
      [caption]="unit.displayName"
      [selected]="true"
      (click)="openFilterPanel('Unit')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let sowType of filteredSowTypes"
      icon="receipt"
      [caption]="sowType.displayName"
      [selected]="true"
      (click)="openFilterPanel('SowType')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let paceOffset of filteredPaceOffset"
      icon="star"
      [caption]="paceOffset.displayName"
      [selected]="true"
      (click)="openFilterPanel('PaceOffset')"
    >
    </shared-filter-chip>

    <shared-filter-chip
      *ngFor="let dateRage of filteredDateRange"
      icon="event"
      [caption]="dateRage.displayName"
      [selected]="true"
      (click)="openFilterPanel('DateRange')"
    >
    </shared-filter-chip>

    <shared-view-option-chip
      *ngFor="let option of selectedViewOptions"
      [icon]="option.icon || 'data_thresholding'"
      [caption]="option.displayName"
      [selected]="true"
      (click)="openOptionPanel(option)"
    >
    </shared-view-option-chip>

    <div class="results-count">
      <ng-container *ngIf="resultsCount">
        SHOWING {{ resultsCount | number : '1.0-0' }} {{ filterCount > 0 ? "FILTERED" : "" }} RESULTS
      </ng-container>
      <ng-content select="[results-info]"></ng-content>
    </div>
  </div>

  <ng-content select="[other-buttons]"></ng-content>
  <button styles-low-button icon="filter_list" [matMenuTriggerFor]="filterMenu" *ngIf="hasFilters">Filter</button>

  <mat-menu #filterMenu="matMenu">
    <button mat-menu-item disabled>FILTER BY</button>
    <button mat-menu-item (click)="openFilterPanel('Tags')" *ngIf="tags">
      <mat-icon>tag</mat-icon>
      Tags
    </button>
    <button mat-menu-item (click)="openFilterPanel('Content Type')" *ngIf="contentTypes">
      <mat-icon>category</mat-icon>
      Content Type
    </button>
    <button mat-menu-item (click)="openFilterPanel('Campaign')" *ngIf="campaigns">
      <mat-icon>campaign</mat-icon>
      Campaign
    </button>
    <button mat-menu-item (click)="openFilterPanel('Status')" *ngIf="statuses">
      <mat-icon>traffic</mat-icon>
      Status
    </button>
    <button mat-menu-item (click)="openFilterPanel('ProjectStatus')" *ngIf="projectStatuses">
      <mat-icon>traffic</mat-icon>
      Status
    </button>
    <button mat-menu-item (click)="openFilterPanel('Sow')" *ngIf="sows">
      <mat-icon>receipt</mat-icon>
      Statement of Work
    </button>
    <button mat-menu-item (click)="openFilterPanel('Owner')" *ngIf="owners">
      <mat-icon>person</mat-icon>
      Ownership
    </button>
    <button mat-menu-item (click)="openFilterPanel('OwnerTeam')" *ngIf="ownersByTeam">
      <mat-icon>person</mat-icon>
      Ownership
    </button>
    <button mat-menu-item (click)="openFilterPanel('Month')" *ngIf="months">
      <mat-icon>event</mat-icon>
      Month
    </button>
    <button mat-menu-item (click)="openFilterPanel('Team')" *ngIf="teams">
      <mat-icon>people</mat-icon>
      Team
    </button>
    <button mat-menu-item (click)="openFilterPanel('Department')" *ngIf="departments">
      <mat-icon>groups_2</mat-icon>
      Department
    </button>
    <button mat-menu-item (click)="openFilterPanel('Organization')" *ngIf="organizations">
      <mat-icon>corporate_fare</mat-icon>
      Organization
    </button>
    <button mat-menu-item (click)="openFilterPanel('IndustrySector')" *ngIf="industrySectors">
      <mat-icon>factory</mat-icon>
      Industry Sector
    </button>
    <button mat-menu-item (click)="openFilterPanel('ProductClass')" *ngIf="productClasses">
      <mat-icon>category</mat-icon>
      Product Class
    </button>
    <button mat-menu-item (click)="openFilterPanel('Template')" *ngIf="templates">
      <mat-icon>view_timeline</mat-icon>
      Product Template
    </button>
    <button mat-menu-item (click)="openFilterPanel('Unit')" *ngIf="units">
      <mat-icon>star</mat-icon>
      Units
    </button>
    <button mat-menu-item (click)="openFilterPanel('SowType')" *ngIf="sowTypes">
      <mat-icon>receipt</mat-icon>
      SOW Types
    </button>
    <button mat-menu-item (click)="openFilterPanel('PaceOffset')" *ngIf="paceOffset">
      <mat-icon>star</mat-icon>
      Pace Offset
    </button>
    <button mat-menu-item (click)="openFilterPanel('DateRange')" *ngIf="dateRange">
      <mat-icon>event</mat-icon>
      Date Range
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="clearAll()">
      <mat-icon>cancel</mat-icon>
      Clear All
    </button>
    <ng-container *ngIf="viewOptions">
      <mat-divider></mat-divider>
      <button mat-menu-item disabled>VIEW BY</button>
      <button mat-menu-item *ngFor="let option of getUniqueViewOptions(viewOptions)" (click)="openOptionPanel(option)">
        <mat-icon>{{ option.icon }}</mat-icon>
        {{ option.typeName }}
      </button>
    </ng-container>
    <ng-container *ngIf="versionOptions">
      <mat-divider></mat-divider>
      <button mat-menu-item disabled>VIEW BY</button>
      <button
        mat-menu-item
        *ngFor="let versionOption of getUniqueVersionOptions(versionOptions)"
        (click)="openOptionPanel(versionOption)"
      >
        <mat-icon>{{ versionOption.icon }}</mat-icon>
        {{ versionOption.typeName }}
      </button>
    </ng-container>
    <ng-container *ngIf="navOptions && navOptions.length > 0">
      <mat-divider></mat-divider>
      <button mat-menu-item disabled>SWITCH TO</button>
      <button mat-menu-item *ngFor="let option of navOptions" [routerLink]="option.route">
        <mat-icon>{{ option.icon }}</mat-icon>
        {{ option.caption }}
      </button>
    </ng-container>
  </mat-menu>
</div>

<shared-filter-panel-tags
  class="panel"
  *ngIf="filterOption === 'Tags'"
  [(tags)]="filteredTags"
  [feedId]="feedId"
  (tagsChange)="filterTagChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-tags>

<shared-filter-panel-sows
  class="panel"
  *ngIf="filterOption === 'Sow'"
  [(sows)]="filteredSows"
  [feedId]="feedId"
  (sowsChange)="filterSowChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-sows>

<shared-filter-panel-status
  class="panel"
  *ngIf="filterOption === 'Status'"
  [(statuses)]="filteredStatuses"
  (statusesChange)="filterStatusChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-status>

<shared-filter-panel-project-status
  class="panel"
  *ngIf="filterOption === 'ProjectStatus'"
  [(statuses)]="filteredStatuses"
  (statusesChange)="filterStatusChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-project-status>

<shared-filter-panel-content-type
  class="panel"
  *ngIf="filterOption === 'Content Type'"
  [(products)]="filteredContentTypes"
  (productsChange)="filterContentTypeChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-content-type>

<shared-filter-panel-templates
  class="panel"
  *ngIf="filterOption === 'Template'"
  [(templates)]="filteredTemplates"
  (templatesChange)="filterTemplateChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-templates>

<shared-filter-panel-product-classes
  class="panel"
  *ngIf="filterOption === 'ProductClass'"
  [(productClasses)]="filteredProductClasses"
  (productClassesChange)="filterProductClassChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-product-classes>

<shared-filter-panel-industry-sectors
  class="panel"
  *ngIf="filterOption === 'IndustrySector'"
  [(industrySectors)]="filteredIndustrySectors"
  (industrySectorsChange)="filterIndustrySectorChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-industry-sectors>

<shared-filter-panel-months
  class="panel"
  *ngIf="filterOption === 'Month'"
  [(months)]="filteredMonths"
  (monthsChange)="filterMonthChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-months>

<shared-filter-panel-owners
  class="panel"
  *ngIf="filterOption === 'Owner'"
  [(owners)]="filteredOwners"
  (ownersChange)="filterOwnerChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-owners>

<shared-filter-panel-owners-by-team
  class="panel"
  *ngIf="filterOption === 'OwnerTeam'"
  [teamId]="teamId"
  [(owners)]="filteredOwnersByTeam"
  (ownersChange)="filterOwnerbyTeamChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-owners-by-team>

<shared-filter-panel-teams
  class="panel"
  *ngIf="filterOption === 'Team'"
  [(teams)]="filteredTeams"
  (teamsChange)="filterTeamChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-teams>

<shared-filter-panel-departments
  class="panel"
  *ngIf="filterOption === 'Department'"
  [(departments)]="filteredDepartments"
  (departmentsChange)="filterDepartmentChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-departments>

<shared-filter-panel-organizations
  class="panel"
  *ngIf="filterOption === 'Organization'"
  [(organizations)]="filteredOrganizations"
  (organizationsChange)="filterOrganizationChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-organizations>

<shared-filter-panel-campaigns
  class="panel"
  *ngIf="filterOption === 'Campaign'"
  [feedId]="feedId"
  [(campaigns)]="filteredCampaigns"
  (campaignsChange)="filterCampaignChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-campaigns>

<shared-filter-panel-units
  class="panel"
  *ngIf="filterOption === 'Unit'"
  [(units)]="filteredUnits"
  (unitsChange)="filterUnitChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-units>

<shared-filter-panel-sow-type
  class="panel"
  *ngIf="filterOption === 'SowType'"
  [(sowTypes)]="filteredSowTypes"
  (sowTypesChange)="filterSowTypeChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-sow-type>

<shared-filter-panel-pace-offset
  class="panel"
  *ngIf="filterOption === 'PaceOffset'"
  [(paceOffset)]="filteredPaceOffset"
  (paceOffsetChange)="filteredPaceOffsetChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-pace-offset>

<shared-filter-panel-date-range
  class="panel"
  *ngIf="filterOption === 'DateRange'"
  [(dateRange)]="filteredDateRange"
  (dateRangeChange)="filterDateRangeChanged()"
  (close)="closePanels()"
>
</shared-filter-panel-date-range>

<shared-view-options-panel
  class="panel"
  *ngIf="viewOption"
  [viewOptions]="getViewTypeOptions(viewOptions, viewOption.type)"
  [(selectedOptions)]="selectedViewOptions"
  (selectedOptionsChange)="selectedViewOptionsChanged(viewOption.type)"
  (close)="closePanels()"
>
</shared-view-options-panel>

<!-- <shared-view-options-panel
  class="panel"
  *ngIf="versionOption"
  [viewOptions]="getViewTypeOptions(versionOptions, viewOption.type)"
  [(selectedOptions)]="selectedVersionOptions"
  (selectedOptionsChange)="selectedVersionOptionsChanged(viewOption.type)"
  (close)="closePanels()"
>
</shared-view-options-panel> -->
